export default __webpack_public_path__ + "/dist/images/notfound.249da1797d0614c23f4aa4c67e0b6a6f.png";